module.exports = __webpack_public_path__ + "media/images/element/medical-a5c10301af28091aef2c1ebe82de4121.svg";